<div class="flex flex-col items-center w-full">
  <!-- Input Container -->
  <div class="flex" [ngClass]="containerClasses">
    <input 
      *ngFor="let digit of digits; let i = index; trackBy: trackByIndex"
      [id]="getInputId(i)"
      type="text"
      inputmode="numeric"
      pattern="[0-9]*"
      maxlength="1"
      [value]="digit"
      [disabled]="disabled"
      [ngClass]="inputClasses"
      class="text-center font-semibold border border-slate-500 rounded-lg focus:border-white focus:ring-2 focus:ring-sky-500 outline-none transition-all duration-200"
      [attr.data-index]="i"
      (input)="onDigitInput($event, i)"
      (keydown)="onDigitKeydown($event, i)"
      (paste)="onPaste($event)"
      (focus)="onTouched()"
      autocomplete="one-time-code"
      autocorrect="off"
      autocapitalize="none"
      spellcheck="false"
    />
  </div>

  <!-- Helper Text -->
  <div *ngIf="style === 'spread'" class="text-xs text-gray-500 text-center mt-2">
    {{ 'SystemAdmin.Components.TwoFactorInput.VerificationCode' | translate: { digits: maxLength } }}
  </div>
</div> 